import { useTalkT } from './useTalkT'
import { HelpZettelStatus } from '@/components/help/HelpZettelStatus'
import { ROLE_LABELS, type Role } from '@/types/role'
import type { HelpZettel } from '@/types/help'
import { playTalkUrl } from './helpAudio'
import { formatTalkDuration, isTranscriptPending } from './talkFormat'
import { TranscriptRetryButton } from './TranscriptRetryButton'
import { useLocalPlayUrl } from './useLocalPlayUrl'

export function WaitingCard({ z, light = false }: { z: HelpZettel; light?: boolean }) {
  const t = useTalkT()
  const url = useLocalPlayUrl(z.opener_id, Boolean(z.has_audio && z.opener_id))
  const pending = isTranscriptPending(z.transcript_pending, z.opener_preview, z.has_audio)
  return (
    <div className={light ? 'talk-list-card help-pair' : 'talk-pair'}>
      <div className="flex justify-between gap-2">
        <span className="role">{ROLE_LABELS[z.sender_role as Role] ?? z.sender_role}</span>
        <HelpZettelStatus status="wartet" light={light} />
      </div>
      <div className={light ? 'text-xs text-gray-600' : 'text-sm text-slate-300'}>
        {pending ? t('talk_transcript_pending') : z.opener_preview}
      </div>
      <TranscriptRetryButton conversationId={z.conversation_id} zettelId={z.id} pending={pending} />
      {url && (
        <div className="talk-meta">
          <button type="button" className="talk-play" aria-label={t('talk_play')} onClick={() => playTalkUrl(z.opener_id || z.id, url)}>
            <i>▶</i>
            {formatTalkDuration(z.audio_duration_ms)}
          </button>
        </div>
      )}
    </div>
  )
}
